// The task the user is currently tracking time into. Set by the tracker's
// task picker (from the user's assigned Taskboards tasks); read by
// activityTracker, which stamps each heartbeat with the task so admin reports
// can break time down per task. Persisted to localStorage so the selection
// survives reloads within a working session.
import { create } from 'zustand'

export interface TrackerCurrentTask {
  /** Taskboard item id (cuid). Sent as the heartbeat `taskAssignmentId`. */
  taskId: string
  /** Human label for display + reports (board / title). */
  label: string
}

const STORAGE_KEY = 'tracker:current-task'

function load(): TrackerCurrentTask | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const t = JSON.parse(raw)
    return t && typeof t.taskId === 'string' ? (t as TrackerCurrentTask) : null
  } catch {
    return null
  }
}

interface State {
  current: TrackerCurrentTask | null
  setCurrent: (t: TrackerCurrentTask | null) => void
}

export const useTrackerCurrentTask = create<State>((set) => ({
  current: load(),
  setCurrent: (current) => {
    try {
      if (current) localStorage.setItem(STORAGE_KEY, JSON.stringify(current))
      else localStorage.removeItem(STORAGE_KEY)
    } catch {
      /* storage disabled — keep in-memory only */
    }
    set({ current })
  },
}))

/** Non-React accessor for the heartbeat service. */
export function getTrackerCurrentTask(): TrackerCurrentTask | null {
  return useTrackerCurrentTask.getState().current
}
